// eslint-disable-next-line prettier/prettier
export { default, getServerSideProps } from '../../../containers/seller';
